<template>
  <el-dialog
    class="dialog"
    title="考核"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    width="600px"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div style="padding:10px;">
      <check-stopwatch ref="stopwatch" v-model="hourNum"></check-stopwatch>
      <el-form class="form" ref="form" label-width="96px">
        <div v-for="(item, index) in list" :key="index">
          <el-form-item class="title" :label="index + 1 + '、'">
            {{ item.questionContent }}
          </el-form-item>
          <template v-if="item.topicType == 1">
            <el-form-item label="请选择答案：">
              <div>
                <el-radio v-model="item.answerGet" label="A">A</el-radio>
                <el-radio v-model="item.answerGet" label="B">B</el-radio>
                <el-radio v-model="item.answerGet" label="C">C</el-radio>
                <el-radio v-model="item.answerGet" label="D">D</el-radio>
              </div>
            </el-form-item>
            <template v-for="(value, key) in item.answerList">
              <el-form-item :key="key">
                {{ value }}
              </el-form-item>
            </template>
          </template>
           <template v-if="item.topicType == 2">
            <el-form-item label="请选择答案：">
              <div>
                <el-radio v-model="item.answerGet" label="A">正确</el-radio>
                <el-radio v-model="item.answerGet" label="B">错误</el-radio>
              </div>
            </el-form-item>
          </template>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="onSubmit">确定</el-button>
      <el-button size="small" @click="cancel">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CheckStopwatch from "./QuestionBankCheckStopwatch";
export default {
  name: "QuestionBankCheck",
  components: {
    CheckStopwatch
  },
  props: {
    checkResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    questionOrder: {
      type: Number,
      default: {
        return: 0
      }
    },
    type: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      requestData: {
        pageSize: 100,
        pageNum: 1,
        questionOrder: ""
      },
      list: [],
      dialogVisible: false,
      hourNum: 0
    };
  },
  created() {},
  mounted() {},
  watch: {
    checkResize: function(newVal, oldVal) {
      if (newVal) {
        this.dialogVisible = true;
        this.requestData.questionOrder = this.questionOrder;
        // 开启定时器
        this.getList();
      }
    }
  },
  computed: {},
  methods: {
    onSubmit() {
      // console.log(this.list);
      let list = this.list.map((element) => {
        return {
          questionId: element.questionId,
          questionAnswerCorrect: element.answerGet
        };
      });
      for (var i = 0; i < list.length; i++) {
        if (list[i].questionAnswerCorrect == "") {
          this.$message("请选择第" + (i + 1) + "道题！");
          return;
        }
      }
      // console.log(list);
      // return;
      // 清空定时器
      this.$refs.stopwatch.clearStartWatch();
      this.getTestScore(list);
    },
    cancel() {
      // 清空定时器
      this.$refs.stopwatch.clearStartWatch();
      this.dialogVisible = false;
    },
    strToArray(str) {
      // console.log(str)

      var arr = str.split("#");
      // console.log(arr);
      return arr;
    },
    async getList() {
      let req = this.requestData;
      this.loading = true;
      let res = await this.$Http.getSafePaper(req);
      this.loading = false;
      if (res.code == 200) {
        // this.responseData = res.data;
        let list = res.data.list;
        list.forEach((element) => {
          // let answerList =
          let arr = this.strToArray(element.questionAnswerContent);
          // console.log(arr);
          element.answerList = arr;
          element.answerGet = "";
        });
        // console.log(list, 111);
        this.list = list;

        this.$refs.stopwatch.startStopwatch();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getTestScore(list) {
      let req = {
        answerData: list,
        submitInformation: {
          answerTime: Number(this.hourNum),
          respondent: JSON.parse(this.$store.state.userInfo).userName,
          schoolId: Number(this.$store.state.schoolId)
        }
      };
      this.loading = true;
      let res = await this.$Http.getTestScore(req);
      this.loading = false;
      if (res.code == 200) {
        this.cancel();
        this.$message({
          type: "success",
          message: "提交成功！"
        });
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog {
  /deep/ .el-dialog__body {
    max-height: 650px;
  }
  /deep/ .form {
    max-height: 500px;
    overflow: scroll;
    .title {
      .el-form-item__label,
      .el-form-item__content {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  .el-input {
    width: 100%;
  }
}
</style>
